

<ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="'image-'+config.COLUMNNAME">
</ngx-spinner>
<div class="post-thumb"><img (click)="onClick()" [src]="image" /></div>
<div *ngFor="let file of files" class="pgbar">
        <nz-progress [nzPercent]="file.progress" nzSize="small" [nzShowInfo]="false"></nz-progress>
</div>
<input type="file" #fileInput id="fileUpload" name="fileUpload" accept="image/*;*.jar" class="hide" (change)="showPreview($event)"/>